export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10437.5148b65d.jpg";